import { useAuth } from '@/hooks/useAuth';

interface LogoutButtonProps {
  className?: string;
}

export const LogoutButton = ({ className }: LogoutButtonProps) => {
  const { logout, inProgress } = useAuth();

  return (
    <button
      onClick={logout}
      disabled={inProgress !== 'none'}
      className={
        className ||
        'rounded-lg bg-red-600 px-4 py-2 font-medium text-white shadow-md transition-colors duration-200 hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50'
      }
    >
      {inProgress !== 'none' ? 'Loading...' : 'Logout'}
    </button>
  );
};
